import { Component, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseContainer } from '../../../base/BaseContainer';
import * as fromRoot from '../../../../core/store';
import { fadeInAnimation } from '../../../../animations';
import * as actions from '../../../../core/store/admin/users/users.actions';
import { ClientUsers } from '../../../../core/store/admin/users/users.interface';
import { map, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'admin-bulk-invite-create',
  templateUrl: './bulk-invite-create.container.html',
  styleUrls: ['./bulk-invite-create.container.scss'],
  animations: [fadeInAnimation],
})
export class BulkInviteCreateContainer extends BaseContainer {
  @ViewChild('fileInput', { static: false }) fileInput;
  downloadExampleInProgress: boolean = false;
  uploadInProgress: boolean = false;
  inProgress: boolean = false;
  finished: boolean = false;
  selectedFile: any;

  constructor() {
    super();
    this.store
      .select('admin')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((admin: { clientUsers: ClientUsers }) => admin && admin.clientUsers.bulk)
      )
      .subscribe(bulk => {
        this.inProgress = bulk.inProgress;
        if (!bulk.inProgress) {
          this.downloadExampleInProgress = false;
          this.uploadInProgress = false;
        }
        this.finished = bulk.finished;
      });
  }

  getExample(): void {
    this.downloadExampleInProgress = true;
    this.store.dispatch(new actions.ClientUserBulkDownloadExampleAction());
  }

  fileSelectedChange(): void {
    const fileBrowser = this.fileInput.nativeElement;
    this.selectedFile = fileBrowser.files && fileBrowser.files[0];
  }

  doUpload(): void {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('image', this.selectedFile);
      this.uploadInProgress = true;
      this.store.dispatch(new actions.ClientUserBulkUploadAction(formData));
    }
  }
}
